class Accordion{
    constructor(){
        this.menu = document.querySelectorAll(".js-menu");
        this.event();
    }

    event(){
        this.menu.forEach(el => {
            el.addEventListener("click", () => { this.toggle(el) })
        });
    }

    toggle(el) {
        let content = el.nextElementSibling
        el.classList.toggle("is-active")
        content.classList.toggle("is-open")
    }
}


export default Accordion

